<template>
  <div class="mt-2">
    <div
      class="MASONARY"
      v-masonry
      column-width=".insight-cols-1"
      item-selector=".insight"
      transition-duration="0s"
      :fit-width="false"
      stagger="0s">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
		name: 'Masonry',
	};
</script>

<style scoped>
  .MASONARY {
    height: auto;
    position: relative;
    width: 100%;
  }
</style>
